module.exports = __webpack_public_path__ + "static/media/homeTabSelected.c657fd02.png";